/**
 * Lead Builder
 * Converts conversation state to LeadData format
 */

import type { LeadData, BuyerData, SellerData } from '../types'
import { generateUUID } from './uuid'

export interface ConversationLeadData {
  clientId: string
  type?: 'buyer' | 'seller'
  name?: string
  email?: string
  phone?: string
  hotLead?: boolean
  scheduledCall?: boolean
  calendlyEventId?: string

  // Buyer fields
  buyerPriceRange?: string
  buyerCities?: string
  buyerPreapproval?: string
  buyerTimeline?: string

  // Seller fields
  sellerAddress?: string
  sellerTimeline?: string
  sellerAgentExperience?: string

  // Metadata
  conversationId?: string
  botName?: string
}

/**
 * Build LeadData from conversation state
 */
export function buildLeadData(conversationData: any): LeadData | null {
  // Check if we have minimum required fields
  if (!conversationData.type || !conversationData.name || !conversationData.email || !conversationData.phone || !conversationData.clientId) {
    return null
  }

  const baseData = {
    leadId: generateUUID(),
    timestamp: new Date().toISOString(),
    type: conversationData.type,
    name: conversationData.name,
    email: conversationData.email,
    phone: conversationData.phone,
    hotLead: conversationData.hotLead || false,
    scheduledCall: conversationData.scheduledCall || false,
    clientId: conversationData.clientId,
    calendlyEventId: conversationData.calendlyEventId,
  }

  if (conversationData.type === 'buyer') {
    return {
      ...baseData,
      type: 'buyer',
      buyerPriceRange: conversationData.buyerPriceRange,
      buyerCities: conversationData.buyerCities,
      buyerPreapproval: conversationData.buyerPreapproval,
      buyerTimeline: conversationData.buyerTimeline,
    } as LeadData & BuyerData
  } else {
    return {
      ...baseData,
      type: 'seller',
      sellerAddress: conversationData.sellerAddress,
      sellerTimeline: conversationData.sellerTimeline,
      sellerAgentExperience: conversationData.sellerAgentExperience,
    } as LeadData & SellerData
  }
}
